import {css} from 'aphrodite';
import React from 'react';
import _ from 'underscore';

import {BenchlingExpressionType} from 'benchling-expressions/BenchlingExpressionTypes';
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {
  sharedStyles,
  ConditionalLogicAllowedValuesBaseProps,
} from 'processes/modals/router-config/RouterConfigConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {IntermediateValueControlledNumericInput} from 'ui-library/inputs/ControlledNumericInput';

export interface ConditionalLogicAllowedValuesProps extends ConditionalLogicAllowedValuesBaseProps {
  dataTestAttrs?: DataTestAttrs;
}

export default function ConditionalLogicValueNumeric(
  props: ConditionalLogicAllowedValuesProps
): JSX.Element | null {
  const typeDef = props.constantExpression?.itemType?.name ?? null;
  const isCompatible = typeDef == null || typeDef === LeafType.DECIMAL || typeDef === LeafType.INTEGER;

  const evaluateExpressionValue = (value: unknown): number | null => {
    if (value == null) {
      return null;
    }

    if (_.isNumber(value)) {
      return value;
    }

    return null;
  };
  return (
    <IntermediateValueControlledNumericInput
      className={css(sharedStyles.routerInputControl)}
      value={evaluateExpressionValue(props.constantExpression?.value)}
      placeholder="enter number"
      isDisabled={!isCompatible}
      onChange={(e) => {
        const newParam = {
          name: props.expression?.parameters?.[1]?.name,
          expression: {
            type: BenchlingExpressionType.CONSTANT_VALUE,
            itemType: {
              name: Number.isInteger(e.target.numericValue) ? LeafType.INTEGER : LeafType.DECIMAL,
            },
            value: e.target.numericValue ?? undefined,
          },
        };
        const newExpression = {
          ...props.expression,
          parameters: [props.expression?.parameters?.[0], newParam],
        };

        props.setExpression(newExpression);
      }}
      dataTestAttrs={{component: 'ConditionalLogicValueNumeric', element: 'root'}}
    />
  );
}
